import { EDealType } from '../types/dealType';

export function getReversDealType(dealType: EDealType): EDealType {
  return dealType === EDealType.Sale ? EDealType.Rent : EDealType.Sale;
}
